import { jsx as y, Fragment as q, jsxs as je } from "react/jsx-runtime";
import { createContext as ce, useState as Ae, useContext as v, useMemo as S, useRef as Me, useEffect as Ie, useId as Ce } from "react";
import n, { z as c } from "zod";
import { JsonLd as D } from "react-schemaorg";
import { useEffectOnce as Le } from "@made-people/react-use-effect-once";
import { isProductMediaImage as Fe } from "@made-people/grease-product";
const xe = n.object({
  "@type": n.literal("BreadcrumbList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: n.object({
        name: n.string(),
        "@id": n.string()
      })
    })
  )
}), Ue = xe;
function Ne(e) {
  const t = Ue.safeParse(e);
  return t.success, t.success;
}
var k = /* @__PURE__ */ ((e) => (e.FAQPage = "FAQPage", e.Product = "Product", e.ProductList = "ProductList", e.MerchantReturnPolicy = "MerchantReturnPolicy", e.ShippingRateSettings = "ShippingRateSettings", e.WebSite = "WebSite", e))(k || {});
const Ee = {
  structuredDataScripts: {},
  addToScripts: () => {
  },
  removeFromScripts: () => {
  }
}, N = ce(Ee), Ve = ({
  children: e
}) => {
  const [t, i] = Ae({}), s = (u, o) => {
    u in t && typeof t[u] < "u" && console.info(
      "Structured data script already exists, overwriting it...",
      u
    ), i({ ...t, [u]: o });
  }, a = (u) => {
    if (!(u in t))
      return;
    const { [u]: o, ...r } = t;
    i(r);
  };
  return /* @__PURE__ */ y(
    N.Provider,
    {
      value: {
        structuredDataScripts: t,
        addToScripts: s,
        removeFromScripts: a
      },
      children: e
    }
  );
}, We = () => {
  const { structuredDataScripts: e } = v(N);
  return e;
}, Qe = () => {
  const { addToScripts: e } = v(N);
  return e;
}, Gt = () => {
  const { removeFromScripts: e } = v(N);
  return e;
}, w = ce(void 0), Kt = (e) => {
  const t = {
    mappers: e.mappers,
    pdpProduct: e.pdpProduct,
    context: e.context,
    offerShippingDetailsSettings: e.offerShippingDetailsSettings,
    merchantReturnPolicySettings: e.merchantReturnPolicySettings,
    breadCrumbs: e.breadCrumbs
  };
  return /* @__PURE__ */ y(w.Provider, { value: t, children: /* @__PURE__ */ y(Ve, { children: e.children }) });
}, Jt = () => {
  const e = v(w);
  if (e === void 0)
    throw new Error(
      "useStructuredDataMappers must be used within a StructuredDataProvider"
    );
  return e.mappers;
}, $e = () => {
  const e = v(w);
  if (e === void 0)
    throw new Error(
      "usePdpProduct must be used within a StructuredDataProvider"
    );
  return e.pdpProduct;
}, R = () => {
  const e = v(w);
  if (e === void 0)
    throw new Error(
      "useStructuredDataContext must be used within a StructuredDataProvider"
    );
  return e.context;
}, qe = () => {
  const e = v(w);
  if (e === void 0)
    throw new Error(
      "useShippingDetailsSettings must be used within a StructuredDataProvider"
    );
  return e.offerShippingDetailsSettings;
}, ze = () => {
  const e = v(w);
  if (e === void 0)
    throw new Error(
      "useBreadCrumbs must be used within a StructuredDataProvider"
    );
  return e.breadCrumbs;
}, Be = () => {
  const e = v(w);
  if (e === void 0)
    throw new Error(
      "useMerchantReturnPolicySettings must be used within a StructuredDataProvider"
    );
  return e.merchantReturnPolicySettings;
}, He = () => {
  const e = ze(), { baseUrl: t, siteSlug: i } = R(), s = S(() => {
    if (typeof e > "u" || typeof t > "u" || typeof i > "u")
      return;
    const a = {
      "@type": "BreadcrumbList",
      itemListElement: e.map((u, o) => {
        const r = u.slug === "" ? u.slug : `/${u.slug}`;
        return {
          "@type": "ListItem",
          position: o,
          item: {
            name: u.label,
            "@id": `${t}/${i}${r}`
          }
        };
      })
    };
    if (Ne(a))
      return a;
  }, [e, t]);
  return typeof s > "u" ? null : /* @__PURE__ */ y(
    D,
    {
      item: {
        "@context": "https://schema.org",
        ...s
      }
    }
  );
}, _e = n.enum([
  "BackOrder",
  "Discontinued",
  "InStock",
  "InStoreOnly",
  "LimitedAvailability",
  "OnlineOnly",
  "OutOfStock",
  "PreOrder",
  "PreSale",
  "SoldOut"
]), z = _e;
function Xt(e) {
  const t = z.safeParse(e);
  return t.success, t.success;
}
const Ge = n.object({
  "@type": n.literal("MonetaryAmount"),
  value: n.number().optional(),
  minValue: n.number().optional(),
  maxValue: n.number().optional(),
  currency: n.string()
}).refine(
  ({ maxValue: e, minValue: t, value: i }) => typeof e > "u" && typeof t > "u" && typeof i == "number" || typeof e == "number" && typeof t == "number" && typeof i > "u",
  {
    message: "Either both `minValue` and `maxValue` or only `value` have to be defined"
  }
), x = Ge;
function fe(e) {
  const t = x.safeParse(e);
  return t.success, t.success;
}
const Ke = n.object({
  "@type": n.literal("DefinedRegion"),
  addressCountry: n.string().nonempty(),
  addressRegion: n.string().nonempty().optional()
}), B = Ke;
function Je(e) {
  const t = B.safeParse(e);
  return t.success, t.success;
}
const Xe = n.object({
  "@type": n.literal("QuantitativeValue"),
  minValue: n.number(),
  maxValue: n.number(),
  unitCode: n.string()
}).transform((e, t) => {
  switch (e.unitCode) {
    case "min":
    case "minutes": {
      e.unitCode = "min";
      break;
    }
    case "h":
    case "hours": {
      e.unitCode = "h";
      break;
    }
    case "days":
    case "d": {
      e.unitCode = "d";
      break;
    }
    case "wk":
    case "weeks": {
      e.unitCode = "wk";
      break;
    }
    default: {
      t.addIssue({
        fatal: !0,
        path: t.path,
        code: "invalid_enum_value",
        received: e.unitCode,
        options: ["minutes", "hours", "d", "weeks"]
      });
      break;
    }
  }
  return e;
}), U = Xe;
function Yt(e) {
  const t = U.safeParse(e);
  return t.success, t.success;
}
function se(e) {
  const t = U.safeParse(e);
  if (t.success)
    return t.data;
}
const Ye = n.enum([
  "Monday",
  "https://schema.org/Monday",
  "Tuesday",
  "https://schema.org/Tuesday",
  "Wednesday",
  "https://schema.org/Wednesday",
  "Thursday",
  "https://schema.org/Thursday",
  "Friday",
  "https://schema.org/Friday",
  "Saturday",
  "https://schema.org/Saturday",
  "Sunday",
  "https://schema.org/Sunday"
]), pe = Ye;
function Zt(e) {
  const t = pe.safeParse(e);
  return t.success, t.success;
}
const Ze = n.object({
  "@type": n.literal("ShippingDeliveryTime"),
  cutoffTime: n.string().nonempty().optional(),
  handlingTime: U.optional(),
  transitTime: U.optional(),
  businessDays: n.object({
    "@type": n.literal("OpeningHoursSpecification"),
    dayOfWeek: pe.array()
  })
}), de = Ze;
function et(e) {
  const t = de.safeParse(e);
  return t.success, t.success;
}
const tt = n.object({
  "@type": n.literal("OfferShippingDetails"),
  shippingSettingsLink: n.string(),
  deliveryTime: de.optional(),
  shippingRate: x,
  shippingDestination: B
}), le = tt;
function nt(e) {
  const t = le.safeParse(e);
  return t.success, t.success;
}
const it = n.object({
  "@type": n.literal("Offer"),
  price: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: z,
  shippingDetails: le.optional()
}), H = it;
function en(e) {
  const t = H.safeParse(e);
  return t.success, t.success;
}
const rt = n.object({
  "@type": n.literal("ProductModel"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  mpn: n.string().nonempty().optional(),
  size: n.string().nonempty().optional(),
  image: n.string().array().nonempty().optional(),
  color: n.string().nonempty().optional(),
  offers: H,
  url: n.string()
}).refine(
  (e) => !(typeof e.size > "u" && typeof e.color > "u"),
  {
    message: "Both `size` and `color` cannot be undefined simultaneously on a product model"
  }
), _ = rt;
function tn(e) {
  return _.safeParse(e).success;
}
function st(e) {
  if (typeof e > "u")
    return;
  const t = _.safeParse(e);
  if (t.success)
    return t.data;
}
const ot = n.object({
  "@type": n.literal("AggregateOffer"),
  lowPrice: n.number(),
  highPrice: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: z
}), ge = ot;
function nn(e) {
  const t = ge.safeParse(e);
  return t.success, t.success;
}
const at = n.object({
  "@type": n.literal("AggregateRating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  ratingCount: n.number().int().positive().optional(),
  reviewCount: n.number().int().positive().optional()
}), G = at;
function rn(e) {
  return G.safeParse(e).success;
}
function sn(e) {
  const t = G.safeParse(e);
  if (t.success)
    return t.data;
}
const ut = n.object({
  "@type": n.literal("Rating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional()
}), K = ut;
function on(e) {
  return K.safeParse(e).success;
}
function an(e) {
  const t = K.safeParse(e);
  if (t.success)
    return t.data;
}
const ct = n.object({
  "@type": n.literal("Review"),
  reviewBody: n.string().optional(),
  reviewRating: K.optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional(),
  datePublished: n.string().optional(),
  name: n.string().optional(),
  description: n.string().optional(),
  reviewAspect: n.string().optional(),
  positiveNotes: n.string().optional(),
  negativeNotes: n.string().optional()
}), J = ct;
function un(e) {
  return J.safeParse(e).success;
}
function cn(e) {
  const t = J.safeParse(e);
  if (t.success)
    return t.data;
}
const ft = n.object({
  "@type": n.literal("MerchantReturnPolicy"),
  applicableCountry: n.string().optional(),
  returnPolicyCategory: n.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: n.number().min(0).optional(),
  returnMethod: n.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: n.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: n.boolean().optional()
}), me = ft;
function fn(e) {
  const t = me.safeParse(e);
  return t.success, t.success;
}
const pt = n.object({
  "@type": n.literal("Product"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  description: n.string().nonempty().optional(),
  image: n.string().array().nonempty().optional(),
  offers: H.or(ge),
  model: n.array(_).nonempty().optional(),
  url: n.string(),
  aggregateRating: G.optional(),
  review: n.array(J).optional(),
  hasMerchantReturnPolicy: me.optional()
}).refine(
  (e) => {
    var t;
    return !(typeof e.model < "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "Offer");
  },
  {
    message: "If `model` is defined, `offers` need to be of type 'AggregateOffer'"
  }
).refine(
  (e) => {
    var t;
    return !(typeof e.model > "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "AggregateOffer");
  },
  {
    message: "If `model` is undefined, `offers` need to be of type 'Offer'"
  }
).refine(
  (e) => !(typeof e.model > "u" && typeof e.offers > "u"),
  { message: "Both `model` and `offers` cannot be undefined simultaneously" }
), X = pt;
function dt(e) {
  return X.safeParse(e).success;
}
function lt(e) {
  const t = X.safeParse(e);
  if (t.success)
    return t.data;
}
const gt = n.object({
  "@type": n.literal("ItemList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: X
    })
  )
}), ye = gt;
function mt(e) {
  return ye.safeParse(e).success;
}
function pn(e) {
  const t = ye.safeParse(e);
  if (t.success)
    return t.data;
}
const he = c.object({
  applicableCountry: c.string().optional(),
  returnPolicyCategory: c.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: c.number().min(0).optional(),
  returnMethod: c.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: c.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: c.boolean().optional()
});
function dn(e) {
  return he.safeParse(e).success;
}
const be = he.array().nonempty();
function yt(e) {
  return be.safeParse(e).success;
}
function ln(e, t) {
  const i = be.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const ht = (e) => {
  const { country: t, baseUrl: i } = R();
  return S(() => {
    var a, u, o, r, f, d;
    return yt(e) ? {
      "@type": "MerchantReturnPolicy",
      applicableCountry: ((a = e == null ? void 0 : e[0]) == null ? void 0 : a.applicableCountry) || t,
      returnPolicyCategory: (u = e == null ? void 0 : e[0]) == null ? void 0 : u.returnPolicyCategory,
      merchantReturnDays: (o = e == null ? void 0 : e[0]) == null ? void 0 : o.merchantReturnDays,
      returnMethod: (r = e == null ? void 0 : e[0]) == null ? void 0 : r.returnMethod,
      returnFees: (f = e == null ? void 0 : e[0]) == null ? void 0 : f.returnFees,
      inStoreReturnsOffered: (d = e == null ? void 0 : e[0]) == null ? void 0 : d.inStoreReturnsOffered
    } : void 0;
  }, [e, t, i]);
}, oe = c.object({
  unit: c.enum(["days", "hours", "minutes", "seconds"]),
  endTime: c.number(),
  startTime: c.number(),
  isEnabled: c.boolean()
}), Se = c.object({
  cutoffTime: c.string().optional(),
  handlingTime: oe,
  transitTime: oe
});
function gn(e) {
  const t = Se.safeParse(e);
  return t.success || console.warn(
    "Failed to parse type shippingDeliveryTimeSettingSchema: ",
    t.error
  ), t.success;
}
const ve = c.object({
  countries: c.string().array().nonempty(),
  deliveryTime: Se.array().min(1).max(1).optional(),
  region: c.string().optional(),
  shippingRateMin: c.string(),
  shippingRateMax: c.string(),
  freeShippingThreshold: c.string().optional(),
  shippingSettingsLink: c.object({
    href: c.string()
  }).optional()
});
function mn(e) {
  return ve.safeParse(e).success;
}
const Pe = ve.array().nonempty();
function j(e) {
  return Pe.safeParse(e).success;
}
function yn(e, t) {
  const i = Pe.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const bt = (e) => {
  const { country: t, currencyCode: i } = R();
  return S(() => {
    if (!j(e))
      return;
    const s = /* @__PURE__ */ new Map();
    for (const a of e) {
      if (!a.countries.includes(t))
        continue;
      const u = a.countries.join("");
      if (s.has(u)) {
        console.warn(`Duplicate key ${u} in StructuredDataShippingRate`);
        continue;
      }
      let o = parseInt(
        a.shippingRateMin
      );
      isNaN(o) && (o = void 0);
      let r = parseInt(
        a.shippingRateMax
      );
      isNaN(r) && (r = void 0);
      let f;
      typeof o == "number" && typeof r == "number" && (f = {
        "@type": "MonetaryAmount",
        minValue: o,
        maxValue: r,
        currency: i
      }), fe(f) && s.set(u, f);
    }
    if (s.size !== 0)
      return s;
  }, [e, t, i]);
}, St = (e) => {
  const { country: t } = R();
  return S(() => {
    if (!j(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const s of e) {
      if (!s.countries.includes(t))
        continue;
      const a = s.countries.join("");
      if (i.has(a)) {
        console.warn(`Duplicate key ${a} in StructuredDataShippingRate`);
        continue;
      }
      const u = {
        "@type": "DefinedRegion",
        addressCountry: t
      };
      typeof s.region == "string" && s.region.length > 0 && (u.addressRegion = s.region), Je(u) && i.set(a, u);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, vt = (e) => {
  const { country: t } = R();
  return S(() => {
    var s;
    if (!j(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const a of e) {
      if (!a.countries.includes(t))
        continue;
      const u = a.countries.join("");
      if (i.has(u)) {
        console.warn(`Duplicate key ${u} in StructuredDataShippingRate`);
        continue;
      }
      if (typeof a > "u" || !Array.isArray(a.deliveryTime) || typeof a.deliveryTime[0] > "u")
        continue;
      const [o] = a.deliveryTime, r = {
        "@type": "ShippingDeliveryTime",
        businessDays: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "https://schema.org/Monday",
            "https://schema.org/Tuesday",
            "https://schema.org/Wednesday",
            "https://schema.org/Thursday",
            "https://schema.org/Friday"
          ]
        }
      };
      if (o.handlingTime.isEnabled === !0 && (r.handlingTime = {
        "@type": "QuantitativeValue",
        minValue: o.handlingTime.startTime,
        maxValue: o.handlingTime.endTime,
        unitCode: o.handlingTime.unit
      }, r.handlingTime = se(r.handlingTime)), o.transitTime.isEnabled === !0 && (r.transitTime = {
        "@type": "QuantitativeValue",
        minValue: o.transitTime.startTime,
        maxValue: o.transitTime.endTime,
        unitCode: o.transitTime.unit
      }, r.transitTime = se(r.transitTime)), typeof o.cutoffTime == "string" && /(([0-1][0-9])|(2[0-3])):[0-5][0-9]/.test(o.cutoffTime)) {
        const [f, d] = o.cutoffTime.split(
          ":"
        );
        let m = parseInt(f);
        (isNaN(m) || m > 23 || m < 0) && (m = void 0);
        let l = parseInt(d);
        if ((isNaN(l) || l > 59 || l < 0) && (l = void 0), typeof m < "u") {
          const g = /* @__PURE__ */ new Date();
          g.setUTCHours(m, l ?? 0, 0, 0), r.cutoffTime = (s = g.toJSON().split("T")) == null ? void 0 : s[1];
        }
      }
      Object.values(r ?? {}).filter((f) => typeof f < "u").length < 1 || et(r) && i.set(u, r);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, Y = (e) => {
  const t = bt(
    e
  ), i = St(
    e
  ), s = vt(
    e
  ), { country: a, baseUrl: u } = R();
  return S(() => {
    if (!j(e) || typeof i > "u" || typeof t > "u" || typeof s > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const r of e) {
      if (!r.countries.includes(a))
        continue;
      const f = r.countries.join("");
      if (o.has(f)) {
        console.warn(`Duplicate key ${f} in OfferShippingDetails`);
        continue;
      }
      const d = t.get(f), m = i.get(f), l = s.get(f);
      if (typeof d > "u" || typeof m > "u" || typeof l > "u")
        return;
      const g = r == null ? void 0 : r.shippingSettingsLink, h = {
        "@type": "OfferShippingDetails",
        shippingDestination: m,
        deliveryTime: l,
        // @ts-expect-error - setting shippingRate to undefined is intentional
        shippingRate: void 0
      };
      g && (h.shippingSettingsLink = `${u}${g.href}`), fe(d) && (h.shippingRate = d), nt(h) && o.set(f, h);
    }
    if (o.size !== 0)
      return o;
  }, [
    e,
    t,
    i,
    s,
    a,
    u
  ]);
};
function ae(e) {
  if (typeof e != "string")
    return !1;
  try {
    new URL(e);
  } catch {
    return !1;
  }
  return !0;
}
function ue(e, t, i, s, a = !0, u, o) {
  var te, ne, I, ie;
  const r = {
    "@type": "Product",
    name: e.name
  }, f = e.sku, d = e.name, m = e.description, l = e.countryOfOrigin, g = e.priceAsNumber, h = e.brandName, A = (te = e.imageUrls) == null ? void 0 : te.filter((p) => ae(p)), E = e.urlSlug;
  if (typeof f > "u") {
    console.warn(
      `[useStructuredDataProduct]: Invalid sku for product, got ${f}. Product object: `,
      e
    );
    return;
  }
  let O = 1 / 0, M = 0;
  for (let p = 0; p < e.variants.length; ++p) {
    const b = e.variants[p];
    if (typeof b > "u")
      continue;
    const P = {
      "@type": "ProductModel"
    }, C = b.sku, W = b.size, Q = b.ean, L = b.priceAsNumber ?? g;
    let F = (ne = b.imageUrls) == null ? void 0 : ne.filter((De) => ae(De));
    if (typeof F > "u" && (F = A), typeof C == "string" && C.length > 0)
      P.sku = C;
    else {
      console.warn(
        `[useStructuredDataProduct]: Invalid sku for variant, got ${C}. Variant object: `,
        b
      );
      continue;
    }
    typeof d == "string" && d.length > 0 && (P.name = d), typeof W == "string" && W.length > 0 && (P.size = W), typeof Q == "string" && Q.length > 0 && (P.mpn = Q), c.string().nonempty().array().nonempty().safeParse(F).success && (P.image = F), typeof t == "string" && t.length > 0 && typeof L == "number" && typeof b.quantity == "number" && (P.offers = {
      "@type": "Offer",
      price: L,
      priceCurrency: t,
      availability: b.quantity > 0 ? "InStock" : "OutOfStock",
      ...o && { shippingDetails: o }
    }, O = Math.min(O, L), M = Math.max(O, L));
    const $ = b.urlSlug ?? e.urlSlug;
    typeof i == "string" && i.length > 0 && typeof $ == "string" && $.length > 0 && (P.url = `${i}/${s}/${$}`);
    const re = st(P);
    typeof re > "u" || (r.model = [
      re,
      ...r.model ?? []
    ]);
  }
  typeof h == "string" && h.length > 0 && (r.brand = {
    "@type": "Brand",
    name: h
  }), typeof f == "string" && f.length > 0 && (r.sku = f), typeof d == "string" && d.length > 0 && (r.name = d), typeof m == "string" && m.length > 0 && (r.description = m), typeof t == "string" && t.length > 0 && typeof r.model < "u" && (typeof g == "number" || typeof O == "number" && typeof M == "number") ? r.offers = {
    "@type": "AggregateOffer",
    lowPrice: typeof O == "number" ? O : g,
    highPrice: typeof M == "number" ? M : g,
    priceCurrency: t,
    availability: r.model.some(
      (p) => p.offers.availability === "InStock"
    ) ? "InStock" : "OutOfStock"
  } : typeof r.model > "u" && typeof t == "string" && t.length > 0 && typeof g == "number" && (r.offers = {
    "@type": "Offer",
    price: g,
    priceCurrency: t,
    availability: (ie = (I = e.variants) == null ? void 0 : I.some) != null && ie.call(
      I,
      (p) => typeof (p == null ? void 0 : p.quantity) == "number" && (p == null ? void 0 : p.quantity) > 0
    ) ? "InStock" : "OutOfStock",
    ...o && { shippingDetails: o }
  }), typeof i == "string" && i.length > 0 && typeof E == "string" && E.length > 0 && (r.url = `${i}/${s}/${E}`), typeof A < "u" && c.string().array().nonempty().safeParse(A).success && (r.image = A), typeof l == "string" && l.length > 0 && (r.countryOfOrigin = {
    "@type": "Country",
    name: l
  });
  const T = a ? e.aggregateRating : void 0, V = a ? e.reviews : void 0;
  return T && (r.aggregateRating = {
    "@type": "AggregateRating",
    ratingValue: T.ratingValue,
    bestRating: T.bestRating,
    worstRating: T.worstRating,
    reviewCount: T.reviewCount,
    ratingCount: T.ratingCount
  }), V && V.length > 0 && (r.review = V.map((p) => ({
    "@type": "Review",
    reviewBody: p.reviewBody,
    reviewRating: p.reviewRating ? {
      "@type": "Rating",
      ratingValue: p.reviewRating.ratingValue,
      bestRating: p.reviewRating.bestRating,
      worstRating: p.reviewRating.worstRating
    } : void 0,
    author: p.author ? {
      "@type": p.author.type,
      name: p.author.name
    } : void 0,
    datePublished: p.datePublished,
    name: p.name,
    description: p.description,
    reviewAspect: p.reviewAspect,
    positiveNotes: p.positiveNotes,
    negativeNotes: p.negativeNotes
  }))), u && (r.hasMerchantReturnPolicy = u), lt(r);
}
function Re(e) {
  const { currencyCode: t, baseUrl: i, siteSlug: s, country: a } = R(), u = Be(), o = qe(), r = ht(
    u
  ), f = Y(
    o
  ), d = a, m = f == null ? void 0 : f.get(d);
  return S(() => {
    if (!(typeof e > "u" || typeof t > "u" || typeof i > "u" || typeof s > "u"))
      if (Array.isArray(e)) {
        if (e.length === 0)
          return;
        const l = {
          "@type": "ItemList",
          itemListElement: []
        };
        for (let g = 0; g < e.length; ++g) {
          const h = e[g];
          typeof h > "u" || l.itemListElement.push({
            "@type": "ListItem",
            position: g + 1,
            item: ue(
              h,
              t,
              i,
              s,
              !1,
              // Don't include reviews for product lists
              r,
              m
            )
          });
        }
        return mt(l) ? l : void 0;
      } else
        return ue(
          e,
          t,
          i,
          s,
          !0,
          // Include reviews for single product (PDP)
          r,
          m
        );
  }, [
    e,
    t,
    i,
    s,
    r,
    m
  ]);
}
const Pt = ({
  unformattedProducts: e
}) => {
  const t = Re(e), i = Me(0);
  return Ie(() => {
    i.current += 1;
  }, [t]), typeof t > "u" ? null : /* @__PURE__ */ y(
    D,
    {
      item: {
        "@context": "https://schema.org",
        ...t
      }
    },
    i.current
  );
}, Rt = ({ settings: e }) => {
  const t = Y(e);
  return /* @__PURE__ */ y(q, { children: [...(t == null ? void 0 : t.entries()) ?? []].map(
    ([i, s]) => /* @__PURE__ */ y(
      D,
      {
        item: {
          "@context": "https://schema.org",
          ...s
        }
      },
      i
    )
  ) });
}, wt = n.object({
  "@type": n.literal("ShippingRateSettings"),
  shippingRate: x,
  freeShippingThreshold: x,
  shippingDestination: B
}), we = wt;
function Ot(e) {
  const t = we.safeParse(e);
  return t.success, t.success;
}
function hn(e) {
  const t = we.safeParse(e);
  if (t.success)
    return t.data;
}
const Tt = ({ settings: e }) => {
  const { country: t, currencyCode: i, currentPath: s } = R(), a = Y(e), u = S(() => {
    var r;
    if (!j(e) || typeof a > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const f of e) {
      if (!f.countries.includes(t))
        continue;
      const d = f.countries.join(""), m = a.get(d);
      if (typeof m > "u" || ((r = f.shippingSettingsLink) == null ? void 0 : r.href) !== s)
        continue;
      const l = {
        ...m,
        "@type": "ShippingRateSettings"
      };
      if (delete l.deliveryTime, delete l.shippingSettingsLink, typeof f.freeShippingThreshold == "string") {
        let g = parseFloat(
          f.freeShippingThreshold
        );
        isNaN(g) && (g = void 0), typeof g < "u" && (l.freeShippingThreshold = {
          "@type": "MonetaryAmount",
          value: g,
          currency: i
        });
      }
      if (o.has(d)) {
        console.warn(`Duplicate key ${d} in ShippingRateSettings`);
        continue;
      }
      Ot(l) && o.set(d, l);
    }
    if (o.size !== 0)
      return o;
  }, [a, e]);
  return /* @__PURE__ */ y(q, { children: [...(u == null ? void 0 : u.entries()) ?? []].map(
    ([o, r]) => /* @__PURE__ */ y(
      D,
      {
        item: {
          "@context": "https://schema.org",
          ...r
        }
      },
      o
    )
  ) });
}, bn = ({
  offerShippingDetailsSettings: e
}) => {
  const t = $e(), i = We();
  return /* @__PURE__ */ je(q, { children: [
    Object.entries(i).filter(([s]) => !(typeof t < "u" && s === k.ProductList)).map(([, s]) => s),
    /* @__PURE__ */ y(He, {}),
    /* @__PURE__ */ y(Rt, { settings: e }),
    /* @__PURE__ */ y(
      Tt,
      {
        settings: e
      }
    ),
    /* @__PURE__ */ y(Pt, { unformattedProducts: t })
  ] });
}, kt = n.object({
  "@type": n.literal("FAQPage"),
  mainEntity: n.array(
    n.object({
      "@type": n.literal("Question"),
      name: n.string(),
      acceptedAnswer: n.object({
        "@type": n.literal("Answer"),
        text: n.string()
      })
    })
  ).nonempty()
}), Dt = kt;
function jt(e) {
  const t = Dt.safeParse(e);
  return t.success, t.success;
}
const Z = (e, t) => {
  const i = Qe(), s = Ce();
  Le(
    () => {
      if (typeof e > "u")
        return;
      const a = `schema-org-script-${e.name ?? e["@type"] ?? t}-${s}`, u = /* @__PURE__ */ y(
        D,
        {
          item: {
            "@context": "https://schema.org",
            ...e
          }
        },
        a
      );
      i(t, u);
    },
    {
      ifDefined: [e]
    }
  );
}, At = (e) => {
  if (e.length === 0)
    return;
  const t = {
    "@type": "FAQPage"
  };
  let i = [];
  for (const { q: s, a } of e) {
    if (typeof s != "string" || typeof a != "string") {
      console.warn("[useInjectFAQPage]: Wrong input, got", { q: s, a });
      continue;
    }
    i = [
      ...i,
      {
        "@type": "Question",
        name: s,
        acceptedAnswer: {
          "@type": "Answer",
          text: a
        }
      }
    ];
  }
  if (t.mainEntity = i, !jt(t)) {
    console.warn(
      "[useInjectFAQPage]: Could not generate FAQ Page structured data from: ",
      e,
      " generated: ",
      t,
      ", which is not valid SchemaOrg format"
    );
    return;
  }
  return t;
}, Sn = (e) => {
  const t = S(() => {
    if (!(typeof e > "u"))
      return At(e);
  }, [e]);
  Z(t, k.FAQPage);
}, vn = (e) => {
  const t = Re(e);
  Z(
    t,
    dt(t) ? k.Product : k.ProductList
  );
}, Mt = n.object({
  "@type": n.literal("SearchAction"),
  target: n.object({
    "@type": n.literal("EntryPoint"),
    urlTemplate: n.string()
  }),
  "query-input": n.string()
}), Oe = Mt;
function Pn(e) {
  return Oe.safeParse(e).success;
}
const It = n.object({
  "@type": n.literal("ImageObject"),
  url: n.string(),
  contentUrl: n.string().optional(),
  caption: n.string().optional(),
  inLanguage: n.string().optional()
}), Te = It;
function Rn(e) {
  return Te.safeParse(e).success;
}
const Ct = n.object({
  "@type": n.literal("WebSite"),
  "@context": n.literal("https://schema.org/"),
  url: n.string(),
  name: n.string(),
  description: n.string().optional(),
  inLanguage: n.string().optional(),
  keywords: n.string().optional(),
  potentialAction: Oe.optional(),
  logo: Te.optional(),
  sameAs: n.array(n.string()).optional()
}), Lt = Ct;
function Ft(e) {
  return Lt.safeParse(e).success;
}
const xt = (e) => {
  const t = {
    "@type": "WebSite",
    "@context": "https://schema.org/",
    url: e.url,
    name: e.name
  };
  if (e.description && (t.description = e.description), e.inLanguage && (t.inLanguage = e.inLanguage), e.keywords && (t.keywords = e.keywords), e.searchActionUrlTemplate && (t.potentialAction = {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: e.searchActionUrlTemplate
    },
    "query-input": "required name=search_term_string"
  }), e.logoUrl && (t.logo = {
    "@type": "ImageObject",
    url: e.logoUrl,
    contentUrl: e.logoUrl
  }, e.logoCaption && (t.logo.caption = e.logoCaption), e.logoLanguage && (t.logo.inLanguage = e.logoLanguage)), e.sameAs && e.sameAs.length > 0 && (t.sameAs = e.sameAs), !Ft(t)) {
    console.warn(
      "[useInjectWebSite]: Could not generate WebSite structured data from: ",
      e,
      " generated: ",
      t,
      ", which is not valid SchemaOrg format"
    );
    return;
  }
  return t;
}, wn = (e) => {
  const t = S(() => {
    if (!(typeof e > "u"))
      return xt(e);
  }, [e]);
  Z(t, k.WebSite);
}, Ut = n.object({
  a: n.string(),
  q: n.string()
}), ke = n.object({
  qa: n.array(Ut)
});
function On(e) {
  return ke.safeParse(e).success;
}
function Tn(e) {
  const t = ke.safeParse(e);
  if (t.success)
    return t.data;
}
const kn = n.object({
  name: n.string(),
  description: n.string().optional(),
  keywords: n.string().optional(),
  logoUrl: n.string(),
  logoCaption: n.string().optional(),
  sameAs: n.string().optional()
}), Nt = c.object({
  sku: c.string(),
  name: c.string(),
  uri: c.string(),
  excerpt: c.string().optional(),
  brand: c.string().optional(),
  countryOrigin: c.string().optional().nullable(),
  price: c.object({
    priceAsNumber: c.number()
  }),
  mediaUrls: c.array(c.string()),
  frontendItems: c.array(
    c.object({
      sku: c.string(),
      name: c.string(),
      ean: c.string().optional(),
      quantity: c.number().optional()
    })
  )
});
function Et(e) {
  const t = Nt.safeParse(e);
  return t.success || console.warn(
    "Type validation of StructuredDataFormattableCentraProduct failed: ",
    t.error
  ), t.success;
}
function Dn(e) {
  if (!(typeof e > "u") && Et(e))
    return {
      sku: e.sku,
      name: e.name,
      description: e.excerpt,
      brandName: e.brand,
      priceAsNumber: e.price.priceAsNumber,
      imageUrls: e.mediaUrls,
      countryOfOrigin: e.countryOrigin,
      urlSlug: e.uri,
      variants: e.frontendItems.map((t) => ({
        sku: t.sku,
        size: t.name,
        ean: t.ean,
        imageUrls: e.mediaUrls,
        quantity: t.quantity
      }))
    };
}
function jn(e) {
  switch (e.dataModel) {
    case "simple":
      return Vt(e);
    case "with_variants":
      return Wt(e);
    case "bundle":
      return Qt(e);
    default:
      throw new Error("Unsupported product type" + e.dataModel);
  }
}
function Vt(e) {
  const t = ee(e);
  return {
    sku: e.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.sku,
        size: "One size",
        ean: e.ean,
        imageUrls: t,
        quantity: e.inventory.quantity
      }
    ]
  };
}
function Wt(e) {
  var i;
  const t = ee(e);
  return {
    sku: e.base.productId,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: (i = e.variants[0]) == null ? void 0 : i.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: e.variants.map((s) => ({
      sku: s.sku,
      size: s.label,
      ean: s.ean,
      imageUrls: t,
      quantity: s.inventory.quantity
    }))
  };
}
function Qt(e) {
  const t = ee(e);
  return {
    sku: e.bundlePurchaseInfo.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.bundlePurchaseInfo.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.bundlePurchaseInfo.sku,
        size: "Bundle",
        imageUrls: t,
        quantity: e.bundlePurchaseInfo.inventory.quantity
      }
    ]
  };
}
function ee(e) {
  return e.base.content.media.filter(Fe).map((t) => t.src);
}
export {
  Ve as GearsStructuredDataContextProvider,
  bn as GearsStructuredDataHeadTag,
  He as StructuredDataBreadcrumbs,
  Pt as StructuredDataProducts,
  Kt as StructuredDataProvider,
  k as StructuredDataScriptName,
  Rt as StructuredDataShippingDetails,
  Tt as StructuredDataShippingRateSettings,
  ge as aggregateOfferSchema,
  G as aggregateRatingSchema,
  Ue as breadcrumbListSchema,
  pe as dayOfWeekSchema,
  Dn as defaultMapCentraProductToStructuredDataProduct,
  B as definedRegionSchema,
  Dt as faqPageSchema,
  jn as greaseProductToUnformattedStructuredDataProduct,
  Te as imageObjectSchema,
  nn as isAggregateOffer,
  rn as isAggregateRating,
  Ne as isBreadcrumbList,
  Zt as isDayOfWeek,
  Je as isDefinedRegion,
  jt as isFAQPage,
  Rn as isImageObject,
  Xt as isItemAvailability,
  fn as isMerchantReturnPolicy,
  yt as isMerchantReturnPolicySettings,
  dn as isMerchantReturnPolicySettingsEntry,
  fe as isMonetaryAmount,
  en as isOffer,
  nt as isOfferShippingDetails,
  j as isOfferShippingDetailsSettings,
  mn as isOfferShippingDetailsSettingsEntry,
  dt as isProduct,
  mt as isProductList,
  tn as isProductModel,
  Yt as isQuantitativeValue,
  on as isRating,
  un as isReview,
  Pn as isSearchAction,
  et as isShippingDeliveryTime,
  gn as isShippingDeliveryTimeSetting,
  Ot as isShippingRateSettings,
  On as isStoryblokFAQPage,
  Ft as isWebSite,
  z as itemAvailabilitySchema,
  me as merchantReturnPolicySchema,
  he as merchantReturnPolicySettingsEntrySchema,
  be as merchantReturnPolicySettingsSchema,
  x as monetaryAmountSchema,
  H as offerSchema,
  le as offerShippingDetailsSchema,
  ve as offerShippingDetailsSettingsEntrySchema,
  Pe as offerShippingDetailsSettingsSchema,
  ye as productListSchema,
  _ as productModelSchema,
  X as productSchema,
  U as quantitativeValueSchema,
  K as ratingSchema,
  J as reviewSchema,
  Oe as searchActionSchema,
  de as shippingDeliveryTimeSchema,
  Se as shippingDeliveryTimeSettingSchema,
  we as shippingRateSettingsSchema,
  oe as storyblokTimeRangeFieldTypeSchema,
  w as structuredDataContext,
  sn as toAggregateRatingOrUndefined,
  ln as toMerchantReturnPolicySettingsOrUndefined,
  yn as toOfferShippingDetailsSettingsOrUndefined,
  pn as toProductListOrUndefined,
  st as toProductModelOrUndefined,
  lt as toProductOrUndefined,
  se as toQuantitativeValueOrUndefined,
  an as toRatingOrUndefined,
  cn as toReviewOrUndefined,
  hn as toShippingRateSettingsOrUndefined,
  Tn as toStoryblokFAQPageOrUndefined,
  Qe as useAddGearsStructuredDataHeadTagScript,
  ze as useBreadCrumbs,
  We as useGearsStructuredDataHeadTagScripts,
  Sn as useInjectFAQPage,
  vn as useInjectStructuredDataProducts,
  wn as useInjectWebSite,
  Be as useMerchantReturnPolicySettings,
  $e as usePdpProduct,
  Gt as useRemoveGearsStructuredDataHeadTagScript,
  qe as useShippingDetailsSettings,
  R as useStructuredDataContext,
  Z as useStructuredDataInjector,
  Jt as useStructuredDataMappers,
  ht as useStructuredDataMerchantReturnPolicy,
  Y as useStructuredDataOfferShippingDetails,
  Re as useStructuredDataProduct,
  vt as useStructuredDataShippingDeliveryTime,
  St as useStructuredDataShippingDestination,
  bt as useStructuredDataShippingRate,
  Lt as webSiteSchema,
  kn as webSiteSettingsSchema
};
